import { Dialog, DialogContainer, DialogHeader, DialogSubtitle } from './Dialog.styles'
import { ButtonContainer } from '@common/components/ButtonContainer'
import { Button } from '@common/components/Button'
import { IonIcon } from '@ionic/react'
import { warningSharp } from 'ionicons/icons'

export const ErrorDialog = ({ onRestart }: { onRestart: () => void }) => {
  return (
    <DialogContainer>
      <Dialog>
        <IonIcon icon={warningSharp} style={{ fontSize: '2.5rem' }} />
        <DialogHeader style={{ marginTop: '0.5rem' }}>Ajdå, något gick snett</DialogHeader>
        <DialogSubtitle>Prova att fylla i din information på nytt</DialogSubtitle>
        <ButtonContainer>
          <Button
            onClick={(e) => {
              e.preventDefault()
              onRestart()
            }}
          >
            Tillbaka
          </Button>
        </ButtonContainer>
      </Dialog>
    </DialogContainer>
  )
}
